import * as React from 'react';
import EventNote from 'material-ui/svg-icons/notification/event-note';
import Pets from 'material-ui/svg-icons/action/pets';
import Bike from 'material-ui/svg-icons/maps/directions-bike';
import LocalActivity from 'material-ui/svg-icons/maps/local-activity';
import StoreMallDirectory from 'material-ui/svg-icons/maps/store-mall-directory';
import Business from 'material-ui/svg-icons/communication/business';
import LocalTaxi from 'material-ui/svg-icons/maps/local-taxi';
import SupervisorAccount from 'material-ui/svg-icons/action/supervisor-account';
import Map from 'material-ui/svg-icons/maps/map';
import Payment from 'material-ui/svg-icons/action/payment';
import Search from 'material-ui/svg-icons/action/search';
import Build from 'material-ui/svg-icons/action/build';
import Description from 'material-ui/svg-icons/action/description';
import Reorder from 'material-ui/svg-icons/action/reorder';
import FormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted';
import CreditCard from 'material-ui/svg-icons/action/credit-card';
import Assignment from 'material-ui/svg-icons/action/assignment';
import Person from 'material-ui/svg-icons/social/person';
import DirectionsCar from 'material-ui/svg-icons/maps/directions-car';
import School from 'material-ui/svg-icons/social/school';
import Work from 'material-ui/svg-icons/action/work';
import Event from 'material-ui/svg-icons/action/event';
import Sms from 'material-ui/svg-icons/notification/sms';
import Class from 'material-ui/svg-icons/action/class';
import PhoneInTalk from 'material-ui/svg-icons/notification/phone-in-talk';
import Palette from 'material-ui/svg-icons/image/palette';
import LocalShipping from 'material-ui/svg-icons/maps/local-shipping';
import Store from 'material-ui/svg-icons/action/store';
import DirectionsBus from 'material-ui/svg-icons/maps/directions-bus';
import LocalPhone from 'material-ui/svg-icons/maps/local-phone';
import Settings from 'material-ui/svg-icons/action/settings';
import People from 'material-ui/svg-icons/social/people';
import History from 'material-ui/svg-icons/action/history';

import { darken } from 'material-ui/utils/colorManipulator';
import { eventsPath, eventsLabel } from '@modules/events/EventsGrid';
import { delictsPath, delictsLabel } from '@modules/delicts/DelictsGrid';
import { tasksPath, tasksLabel } from '@modules/tasks/TasksGrid';
import { employeesLabel, employeesPath } from '@modules/employees/EmployeesGrid';
import { ticketsLabel, ticketsPath } from '@modules/tickets/TicketsGrid';
import { dogsPath, dogsLabel } from '@modules/dogs/DogsGrid';
import { bicyclesPath, bicyclesLabel } from '@modules/bicycles/BicyclesGrid';
import { requestsPayPath, requestsPayLabel } from '@modules/hr-requests/pays/RequestsPayGrid';
import { requestsHolidayLabel, requestsHolidayPath } from '@modules/hr-requests/holidays/RequestsHolidayGrid';
import { claimsLabel, claimsPath } from '@modules/hr-workTimes/claim/ClaimsGrid';
import { dayplansPath, dayplansLabel } from '@modules/hr-dayplans/DayplansGridSingle';
import { shiftsPath } from '@modules/hr-shifts/ShiftsGrid';
import { shiftsCyclesLabel, shiftsCyclesPath } from '@modules/hr-shift-cycles/ShiftCyclesGrid';
import { workPositionsLabel, workPositionsPath } from '@modules/hr-workPositions/WorkPositionsGrid';
import { periodsPath, periodsLabel } from '@modules/hr-templates/periods/PeriodsGrid';
import { daysLabel, daysPath } from '@modules/hr-templates/days/DaysGrid';
import { weeksPath, weeksLabel } from '@modules/hr-templates/weeks/WeeksGrid';
import { calendarsLabel, calendarsPath } from '@modules/hr-templates/calendars/CalendarsGrid';
import { tripsLabel, tripsPath } from '@modules/trips/TripsGrid';
import { inventoryCardsLabel, inventoryCardsPath } from '@modules/inventoryCards/InventoryCardsGrid';
import { protocolsLabel, protocolsPath } from '@modules/protocols/ProtocolsGrid';
import {
  operationalWarehouseLabel,
  operationalWarehousePath
} from '@modules/operationalWarehouse/operationalWarehouseGrid';
import { myItemsLabel, myItemsPath } from '@modules/myItems/myItemsGrid';
import { myRequestsLabel, myRequestsPath } from '@modules/requests/my-requests/myRequestsGrid';
import { wantedPersonLabel, wantedPersonPath } from '@modules/wantedPersons/WantedPersonsGrid';
import { wantedVehiclesLabel, wantedVehiclesPath } from '@modules/wantedVehicles/WantedVehiclesGrid';
import { repairsLabel, repairsPath } from '@modules/repairs/RepairsGrid';
import { reportsLabel, reportsPath } from '@modules/reports/ReportsGrid';
import { errorsLabel, errorsPath } from '@modules/errors/ErrorsGrid';
import { historyLabel, historyPath } from '@modules/history/HistoryGrid';
import { rolesCreateLabel, rolesCreatePath } from '@modules/roles-create/RolesCreateGrid';
import { rolesAssignLabel, rolesAssignPath } from '@modules/roles-assing/RolesAssignGrid';
import { jobsLabel, jobsPath } from '@modules/jobs/JobsGrid';
import { mapLabel, mapPath } from '@modules/maps/Map';
import { workDayTypesLabel, workDayTypesPath } from '@modules/hr-workDayTypes/WorkDayTypesGrid';
import {
  tasksCode,
  dogsCode,
  bicyclesCode,
  mapCode,
  hrCode,
  warehousesCode,
  tripsCode,
  wantedPersonCode,
  wantedVehiclesCode,
  operationalWarehousesCode
} from 'src/moduleCodes';
import {
  eventsPermission,
  tasksPermission,
  employeesPermission,
  ticketsPermission,
  dogsPermission,
  bicyclesPermission,
  mapPermission,
  hrMyPermission,
  hrMyPlansPermission,
  hrDayplansPermission,
  hrOverviewsPermission,
  hrRequestsPermission,
  hrWorkTimesPermission,
  hrTemplatesPermission,
  hrShiftsPermission,
  hrWorkPositionsPermission,
  warehouseProtocolsPermission,
  warehouseInventoryCardsPermission,
  tripsPermission,
  wantedPermission,
  repairsPermission,
  reportsPermission,
  dictionariesPermission,
  historyPermission,
  administrationPermission,
  delictsPermission,
  workDayTypesPermission,
  operationalWarehouseOwnListPermission,
  operationalWarehouseRequestListPermission,
  operationalWarehousePermission
} from 'src/permissions';
import { requestsLabel, requestsPath } from '@modules/requests/requestsGrid';

const nestedListStyle = color => ({
  backgroundColor: darken(color, 0.1),
  padding: 0,
  borderBottom: `1px solid ${darken(color, 0.3)}`
});
export const sidebarItems = color => [
  {
    id: 'events',
    primaryText: eventsLabel,
    path: eventsPath,
    permissions: [eventsPermission],
    open: false,
    rightIcon: <EventNote color="white" />,
    listItemProps: {
      leftIcon: <EventNote color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'delicts',
    primaryText: delictsLabel,
    path: delictsPath,
    permissions: [delictsPermission],
    open: false,
    rightIcon: <LocalActivity color="white" />,
    listItemProps: {
      leftIcon: <LocalActivity color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'tasks',
    primaryText: tasksLabel,
    path: tasksPath,
    permissions: [tasksPermission],
    moduleCodes: [tasksCode],
    open: false,
    rightIcon: <FormatListBulleted color="white" />,
    listItemProps: {
      leftIcon: <FormatListBulleted color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'employees',
    primaryText: employeesLabel,
    path: employeesPath,
    permissions: [employeesPermission],
    open: false,
    rightIcon: <SupervisorAccount color="white" />,
    listItemProps: {
      leftIcon: <SupervisorAccount color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'tickets',
    primaryText: ticketsLabel,
    path: ticketsPath,
    permissions: [ticketsPermission],
    open: false,
    rightIcon: <Payment color="white" />,
    listItemProps: {
      leftIcon: <Payment color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'dogs',
    primaryText: dogsLabel,
    path: dogsPath,
    permissions: [dogsPermission],
    moduleCodes: [dogsCode],
    open: false,
    rightIcon: <Pets color="white" />,
    listItemProps: {
      leftIcon: <Pets color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'bicycles',
    primaryText: bicyclesLabel,
    path: bicyclesPath,
    permissions: [bicyclesPermission],
    moduleCodes: [bicyclesCode],
    open: false,
    rightIcon: <Bike color="white" />,
    listItemProps: {
      leftIcon: <Bike color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'map',
    primaryText: mapLabel,
    path: mapPath,
    permissions: [mapPermission],
    moduleCodes: [mapCode],
    open: false,
    rightIcon: <Map color="white" />,
    listItemProps: {
      leftIcon: <Map color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'hr',
    primaryText: 'Personalistika',
    permissions: [
      hrMyPlansPermission,
      hrMyPermission,
      hrOverviewsPermission,
      hrRequestsPermission,
      hrWorkTimesPermission,
      hrTemplatesPermission,
      hrDayplansPermission,
      hrShiftsPermission,
      hrWorkPositionsPermission
    ],
    moduleCodes: [hrCode],
    open: false,
    rightIcon: <SupervisorAccount color="white" />,
    listItemProps: {
      leftIcon: <SupervisorAccount color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'my-plan',
    parent: 'hr',
    primaryText: 'Moje plány',
    path: '/hr/plans',
    permissions: [hrMyPlansPermission],
    open: false,
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'my',
    parent: 'hr',
    primaryText: 'Můj přehled',
    path: '/hr/my',
    permissions: [hrMyPermission],
    open: false,
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'hr-overviews',
    parent: 'hr',
    primaryText: 'Přehled zaměstnanců',
    path: '/hr/overviews',
    permissions: [hrOverviewsPermission],
    open: false,
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'hr-requests',
    parent: 'hr',
    primaryText: 'Žádosti',
    permissions: [hrRequestsPermission],
    open: false
  },
  {
    id: 'hr-requests-pay',
    parent: 'hr-requests',
    primaryText: requestsPayLabel,
    path: requestsPayPath,
    open: false
  },
  {
    id: 'hr-requests-holiday',
    parent: 'hr-requests',
    primaryText: requestsHolidayLabel,
    path: requestsHolidayPath,
    open: false
  },
  {
    id: 'hr-workTimes',
    parent: 'hr',
    primaryText: 'Časové položky',
    permissions: [hrWorkTimesPermission],
    open: false
  },
  {
    id: 'hr-workTimes-overview',
    parent: 'hr-workTimes',
    primaryText: 'Náhled',
    path: '/hr/work-times/overview',
    open: false
  },
  {
    id: 'hr-workTimes-settings',
    parent: 'hr-workTimes',
    primaryText: claimsLabel,
    path: claimsPath,
    open: false
  },
  {
    id: 'hr-templates',
    parent: 'hr',
    primaryText: 'Šablony',
    permissions: [hrTemplatesPermission],
    open: false
  },
  {
    id: 'templates-periods',
    parent: 'hr-templates',
    primaryText: periodsLabel,
    path: periodsPath,
    open: false
  },
  {
    id: 'templates-day',
    parent: 'hr-templates',
    primaryText: daysLabel,
    path: daysPath,
    open: false
  },
  {
    id: 'templates-week',
    parent: 'hr-templates',
    primaryText: weeksLabel,
    path: weeksPath,
    open: false
  },
  {
    id: 'templates-calendar',
    parent: 'hr-templates',
    primaryText: calendarsLabel,
    path: calendarsPath,
    open: false
  },
  {
    id: 'hr-dayplans',
    parent: 'hr',
    primaryText: 'Denní plánování',
    permissions: [hrDayplansPermission],
    open: false
  },
  {
    id: 'hr-dayplans-items',
    parent: 'hr-dayplans',
    primaryText: dayplansLabel,
    path: dayplansPath,
    open: false
  },
  {
    id: 'hr-dayplans-bulk',
    parent: 'hr-dayplans',
    primaryText: 'Hromadné plánování',
    path: '/hr/dayplans/bulk',
    open: false
  },
  {
    id: 'hr-shifts',
    parent: 'hr',
    primaryText: 'Směny',
    permissions: [hrShiftsPermission],
    open: false
  },
  {
    id: 'hr-shifts-shifts',
    parent: 'hr-shifts',
    primaryText: 'Směny',
    path: shiftsPath,
    open: false
  },
  {
    id: 'hr-shift-cycles',
    parent: 'hr-shifts',
    primaryText: shiftsCyclesLabel,
    path: shiftsCyclesPath,
    open: false
  },
  {
    id: 'hr-workPositions',
    parent: 'hr',
    primaryText: workPositionsLabel,
    path: workPositionsPath,
    permissions: [hrWorkPositionsPermission],
    open: false
  },
  {
    id: 'hr-workDayTypes',
    parent: 'hr',
    primaryText: workDayTypesLabel,
    path: workDayTypesPath,
    permissions: [workDayTypesPermission],
    open: false
  },
  {
    id: 'warehouses',
    primaryText: 'Sklady',
    moduleCodes: [warehousesCode],
    permissions: [warehouseInventoryCardsPermission, warehouseProtocolsPermission],
    open: false,
    listItemProps: {
      leftIcon: <StoreMallDirectory color="white" style={{ width: 18 }} />,
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'inventory-cards',
    parent: 'warehouses',
    primaryText: inventoryCardsLabel,
    path: inventoryCardsPath,
    open: false,
    permissions: [warehouseInventoryCardsPermission],
    rightIcon: <CreditCard color="white" />
  },
  {
    id: 'protocols',
    parent: 'warehouses',
    primaryText: protocolsLabel,
    path: protocolsPath,
    open: false,
    permissions: [warehouseProtocolsPermission],
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'operational-warehouse-parent',
    primaryText: operationalWarehouseLabel,
    moduleCodes: [operationalWarehousesCode],
    permissions: [operationalWarehousePermission],
    open: false,
    listItemProps: {
      leftIcon: <Business color="white" style={{ width: 18 }} />,
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'operational-warehouse',
    parent: 'operational-warehouse-parent',
    primaryText: operationalWarehouseLabel,
    path: operationalWarehousePath,
    open: false,
    permissions: [operationalWarehousePermission],
    rightIcon: <Business color="white" />
  },
  {
    id: 'my-items',
    parent: 'operational-warehouse-parent',
    primaryText: myItemsLabel,
    path: myItemsPath,
    open: false,
    permissions: [operationalWarehousePermission],
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'my-requests',
    parent: 'operational-warehouse-parent',
    primaryText: myRequestsLabel,
    path: myRequestsPath,
    open: false,
    permissions: [operationalWarehouseOwnListPermission],
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'requests',
    parent: 'operational-warehouse-parent',
    primaryText: requestsLabel,
    path: requestsPath,
    open: false,
    permissions: [operationalWarehouseRequestListPermission],
    rightIcon: <Assignment color="white" />
  },
  {
    id: 'trips',
    primaryText: tripsLabel,
    path: tripsPath,
    moduleCodes: [tripsCode],
    permissions: [tripsPermission],
    open: false,
    rightIcon: <LocalTaxi color="white" />,
    listItemProps: {
      leftIcon: <LocalTaxi color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'wanted',
    primaryText: 'Pátrání',
    open: false,
    permissions: [wantedPermission],
    moduleCodes: [wantedPersonCode, wantedVehiclesCode],
    listItemProps: {
      leftIcon: <Search color="white" style={{ width: 18 }} />,
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'persons',
    parent: 'wanted',
    primaryText: wantedPersonLabel,
    path: wantedPersonPath,
    moduleCodes: [wantedPersonCode],
    open: false,
    rightIcon: <Person color="white" />
  },
  {
    id: 'vehicles',
    parent: 'wanted',
    primaryText: wantedVehiclesLabel,
    path: wantedVehiclesPath,
    moduleCodes: [wantedVehiclesCode],
    open: false,
    rightIcon: <DirectionsCar color="white" />
  },
  {
    id: 'repairs',
    primaryText: repairsLabel,
    path: repairsPath,
    open: false,
    permissions: [repairsPermission],
    rightIcon: <Build color="white" />,
    listItemProps: {
      leftIcon: <Build color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'reports',
    primaryText: reportsLabel,
    path: reportsPath,
    open: false,
    permissions: [reportsPermission],
    rightIcon: <Description color="white" />,
    listItemProps: {
      leftIcon: <Description color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'dictionaries',
    primaryText: 'Číselníky',
    open: false,
    permissions: [dictionariesPermission],
    listItemProps: {
      leftIcon: <Reorder color="white" style={{ width: 18 }} />,
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'dictionary-divisions',
    parent: 'dictionaries',
    primaryText: 'Územní členění',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'countries',
    parent: 'dictionary-divisions',
    primaryText: 'Státy',
    path: '/dictionary/countries',
    open: false,
    rightIcon: <i className="fas fa-globe-americas" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'regions',
    parent: 'dictionary-divisions',
    primaryText: 'Kraje',
    path: '/dictionary/regions',
    open: false,
    rightIcon: <i className="fas fa-map-marked" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'counties',
    parent: 'dictionary-divisions',
    primaryText: 'Okresy',
    path: '/dictionary/counties',
    open: false,
    rightIcon: <i className="fas fa-map-marked-alt" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'municipalities',
    parent: 'dictionary-divisions',
    primaryText: 'Obce',
    path: '/dictionary/municipalities',
    open: false,
    rightIcon: <i className="fas fa-building" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'municipality-parts',
    parent: 'dictionary-divisions',
    primaryText: 'Části obcí',
    path: '/dictionary/municipality-parts',
    open: false,
    rightIcon: <i className="far fa-building" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'streets',
    parent: 'dictionary-divisions',
    primaryText: 'Ulice',
    path: '/dictionary/streets',
    open: false,
    rightIcon: <i className="fas fa-road" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'places',
    parent: 'dictionary-divisions',
    primaryText: 'Vlastní místa',
    path: '/dictionary/places',
    open: false
  },
  {
    id: 'dictionary-organization-structures',
    parent: 'dictionaries',
    primaryText: 'Organizační struktura',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'departments',
    parent: 'dictionary-organization-structures',
    primaryText: 'Okrsky',
    path: '/dictionary/departments',
    open: false
  },
  {
    id: 'stations',
    parent: 'dictionary-organization-structures',
    primaryText: 'Pracoviště',
    path: '/dictionary/stations',
    open: false
  },
  {
    id: 'dictionary-employees',
    parent: 'dictionaries',
    primaryText: 'Zaměstnanci',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'certificate-types',
    parent: 'dictionary-employees',
    primaryText: 'Typy osvědčení',
    path: '/dictionary/certificate-types',
    open: false,
    rightIcon: <i className="fas fa-certificate" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'educations',
    parent: 'dictionary-employees',
    primaryText: 'Vzdelání',
    path: '/dictionary/educations',
    open: false,
    rightIcon: <School color="white" />
  },
  {
    id: 'work-positions',
    parent: 'dictionary-employees',
    primaryText: 'Pracovní pozice',
    path: '/dictionary/work-positions',
    open: false,
    rightIcon: <Work color="white" />
  },
  {
    id: 'dictionary-events',
    parent: 'dictionaries',
    primaryText: 'Události',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'event-sps',
    parent: 'dictionary-events',
    primaryText: 'Spisová služba',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'event-sps-record-rcase',
    parent: 'event-sps',
    primaryText: 'Věci spisu',
    path: '/dictionary/event-sps-record-rcase',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-sps-document-marks',
    parent: 'event-sps',
    primaryText: 'Značky dokumentu',
    path: '/dictionary/event-sps-document-marks',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-sps-document-dcase',
    parent: 'event-sps',
    primaryText: 'Věci dokumentu',
    path: '/dictionary/event-sps-document-dcase',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-sps-document-record-symbols',
    parent: 'event-sps',
    primaryText: 'Spisové znaky dokumentu',
    path: '/dictionary/event-sps-document-symbols',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-correspodences',
    parent: 'dictionary-events',
    primaryText: 'Korespodence',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'event-correspodences-types',
    parent: 'event-correspodences',
    primaryText: 'Typy',
    path: '/dictionary/event-correspodence-types',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-correspodences-offices',
    parent: 'event-correspodences',
    primaryText: 'Úřady',
    path: '/dictionary/event-correspodence-offices',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-types',
    parent: 'dictionary-events',
    primaryText: 'Typy',
    path: '/dictionary/event-types',
    open: false,
    rightIcon: <Event color="white" />
  },
  {
    id: 'event-report-types',
    parent: 'dictionary-events',
    primaryText: 'Způsoby hlášení',
    path: '/dictionary/event-report-types',
    open: false,
    rightIcon: <Sms color="white" />
  },
  {
    id: 'event-resolutions',
    parent: 'dictionary-events',
    primaryText: 'Způsoby řešení',
    path: '/dictionary/event-resolutions',
    open: false,
    rightIcon: <i className="far fa-lightbulb" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'event-classifications',
    parent: 'dictionary-events',
    primaryText: 'Uživatelská klasifikace',
    path: '/dictionary/event-classifications',
    open: false,
    rightIcon: <Class color="white" />
  },
  {
    id: 'dictionary-delicts',
    parent: 'dictionaries',
    primaryText: 'Přestupky',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'delict-types',
    parent: 'dictionary-delicts',
    primaryText: 'Typy',
    path: '/dictionary/delict-types',
    open: false,
    rightIcon: <LocalActivity color="white" />
  },
  {
    id: 'delict-discoveries',
    parent: 'dictionary-delicts',
    primaryText: 'Způsoby zjištění',
    path: '/dictionary/delict-discoveries',
    open: false,
    rightIcon: <PhoneInTalk color="white" />
  },
  {
    id: 'delict-resolutions-so',
    parent: 'dictionary-delicts',
    primaryText: 'Správní orgány',
    path: '/dictionary/delict-resolutions-so',
    open: false
  },
  {
    id: 'delict-violations',
    parent: 'dictionary-delicts',
    primaryText: 'Porušení',
    path: '/dictionary/delict-violations',
    open: false
  },
  {
    id: 'dictionary-tasks',
    parent: 'dictionaries',
    primaryText: 'Úkoly',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'task-states',
    parent: 'dictionary-tasks',
    primaryText: 'Stavy',
    path: '/dictionary/task-states',
    open: false,
    rightIcon: <i className="fas fa-tasks" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'dictionary-dogs',
    parent: 'dictionaries',
    primaryText: 'Psi',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'dog-breeds',
    parent: 'dictionary-dogs',
    primaryText: 'Plemena',
    path: '/dictionary/dog-breeds',
    open: false,
    rightIcon: <Pets color="white" />
  },
  {
    id: 'dog-color',
    parent: 'dictionary-dogs',
    primaryText: 'Barvy',
    path: '/dictionary/dog-colors',
    open: false,
    rightIcon: <Palette color="white" />
  },
  {
    id: 'dictionary-bicycles',
    parent: 'dictionaries',
    primaryText: 'Kola',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'bicycles-brands',
    parent: 'dictionary-bicycles',
    primaryText: 'Značky',
    path: '/dictionary/bicycles-brands',
    open: false,
    rightIcon: <Pets color="white" />
  },
  {
    id: 'bicycles-colors',
    parent: 'dictionary-bicycles',
    primaryText: 'Barvy',
    path: '/dictionary/bicycles-colors',
    open: false,
    rightIcon: <Pets color="white" />
  },
  {
    id: 'dictionary-warehouse',
    parent: 'dictionaries',
    primaryText: 'Sklad',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'warehouse-suppliers',
    parent: 'dictionary-warehouse',
    primaryText: 'Dodavatelé',
    path: '/dictionary/warehouse-suppliers',
    open: false,
    rightIcon: <LocalShipping color="white" />
  },
  {
    id: 'warehouse-warehouses',
    parent: 'dictionary-warehouse',
    primaryText: 'Sklady',
    path: '/dictionary/warehouse-warehouses',
    open: false,
    rightIcon: <Store color="white" />
  },
  {
    id: 'warehouse-card-categories',
    parent: 'dictionary-warehouse',
    primaryText: 'Kategorie karet',
    path: '/dictionary/warehouse-card-categories',
    open: false
  },
  {
    id: 'warehouse-measure-units',
    parent: 'dictionary-warehouse',
    primaryText: 'Měrné jednotky',
    path: '/dictionary/warehouse-measure-units',
    open: false
  },
  {
    id: 'warehouse-disposal-types',
    parent: 'dictionary-warehouse',
    primaryText: 'Typy likvidace',
    path: '/dictionary/warehouse-disposal-types',
    open: false
  },
  {
    id: 'dictionary-vehicles',
    parent: 'dictionaries',
    primaryText: 'Vozidla',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'vehicle-types',
    parent: 'dictionary-vehicles',
    primaryText: 'Typy',
    path: '/dictionary/vehicle-types',
    open: false,
    rightIcon: <DirectionsBus color="white" />
  },
  {
    id: 'vehicle-brands',
    parent: 'dictionary-vehicles',
    primaryText: 'Značky',
    path: '/dictionary/vehicle-brands',
    open: false,
    rightIcon: <DirectionsCar color="white" />
  },
  {
    id: 'vehicle-colors',
    parent: 'dictionary-vehicles',
    primaryText: 'Barvy',
    path: '/dictionary/vehicle-colors',
    open: false,
    rightIcon: <Palette color="white" />
  },
  {
    id: 'vehicle-calls',
    parent: 'dictionary-vehicles',
    primaryText: 'Volací znaky',
    path: '/dictionary/vehicle-calls',
    open: false,
    rightIcon: <LocalPhone color="white" />
  },
  {
    id: 'service-vehicles',
    parent: 'dictionary-vehicles',
    primaryText: 'Služební vozidla',
    path: '/dictionary/service-vehicles',
    open: false,
    rightIcon: <LocalTaxi color="white" />
  },
  {
    id: 'dictionary-wanted',
    parent: 'dictionaries',
    primaryText: 'Pátrání',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'wantedPerson-reason',
    parent: 'dictionary-wanted',
    primaryText: 'Důvod',
    path: '/dictionary/wantedPerson-reason',
    open: false
  },
  {
    id: 'dictionary-common',
    parent: 'dictionaries',
    primaryText: 'Obecné',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'dictionary-number-sequences',
    parent: 'dictionary-common',
    primaryText: 'Číselné řady',
    path: '/dictionary/number-sequences',
    open: false,
    rightIcon: <i className="fas fa-sort-numeric-down" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'dictionary-personal',
    parent: 'dictionaries',
    primaryText: 'Personalistika',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'dictionary-work-plan',
    parent: 'dictionary-personal',
    primaryText: 'Typy pracovních dnů',
    path: '/dictionary/work-plan',
    open: false,
    rightIcon: <i className="fas fa-sort-numeric-down" style={{ color: 'white', top: 4, right: 0 }} />
  },
  {
    id: 'dictionary-operational-warehouse',
    parent: 'dictionaries',
    primaryText: 'Operační sklad',
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'dictionary-operational-warehouses',
    parent: 'dictionary-operational-warehouse',
    primaryText: 'Operační sklady',
    path: '/dictionary/operational-warehouses',
    open: false,
    rightIcon: <Store color="white" />
  },
  {
    id: 'dictionary-card-categories',
    parent: 'dictionary-operational-warehouse',
    primaryText: 'Kategorie karet',
    path: '/dictionary/card-categories',
    open: false,
    rightIcon: <CreditCard color="white" />
  },
  {
    id: 'history',
    primaryText: historyLabel,
    path: historyPath,
    permissions: [historyPermission],
    open: false,
    rightIcon: <History color="white" />,
    listItemProps: {
      leftIcon: <History color="white" style={{ width: 18 }} />
    }
  },
  {
    id: 'administration',
    primaryText: 'Administrace',
    permissions: [administrationPermission],
    open: false,
    listItemProps: {
      nestedListStyle: nestedListStyle(color)
    }
  },
  {
    id: 'administration-settings',
    parent: 'administration',
    primaryText: 'Nastavení',
    path: '/administration/settings',
    open: false,
    rightIcon: <Settings color="white" />
  },
  {
    id: 'administration-errors',
    parent: 'administration',
    primaryText: errorsLabel,
    path: errorsPath,
    open: false
  },
  {
    id: 'administration-roles',
    parent: 'administration',
    primaryText: 'Role',
    open: false
  },
  {
    id: 'administration-roles-create',
    parent: 'administration-roles',
    primaryText: rolesCreateLabel,
    path: rolesCreatePath,
    open: false
  },
  {
    id: 'administration-roles-assign',
    parent: 'administration-roles',
    primaryText: rolesAssignLabel,
    path: rolesAssignPath,
    open: false
  },
  {
    id: 'administration-jobs',
    parent: 'administration',
    primaryText: jobsLabel,
    path: jobsPath,
    open: false,
    rightIcon: <People color="white" />
  }
];



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebarItems.tsx